import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export const Stars = ({ value, onChange, size = "h-9 w-9" }) => (
  <div className="flex gap-1" data-testid="rating-stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} data-testid={`rating-star-${n}`} className="transition-transform active:scale-90">
        <Star className={`${size} ${n <= value ? "fill-[#F5B301] text-[#F5B301]" : "text-[#D2E0D8]"}`} />
      </button>
    ))}
  </div>
);

const LABEL = ["", "Poor", "Not great", "Okay", "Good", "Excellent!"];

export const RatePartner = ({ b, onDone }) => {
  const { t } = useApp();
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  if (b.status !== "Completed" || !b.staff) return null;
  if (b.rating) return (
    <div className="flex items-center justify-between rounded-2xl bg-white p-4" data-testid="rating-done">
      <span className="text-sm font-semibold text-[#0D3B2B]">{t("You rated")} {b.staff.name}</span>
      <Stars value={b.rating.stars} size="h-5 w-5" />
    </div>
  );
  const send = async () => {
    setBusy(true);
    try { await api.post(`/bookings/${b.booking_id}/rating`, { stars, comment }); toast.success(t("Thanks for your rating!")); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3 rounded-3xl border-2 border-[#F5B301]/60 bg-white p-4" data-testid="rate-partner-card">
      <p className="font-display text-lg font-extrabold text-[#0D3B2B]">{t("How was")} {b.staff.name}?</p>
      <Stars value={stars} onChange={setStars} />
      {stars > 0 && <>
        <p className="text-sm font-semibold text-[#2E9E6B]">{t(LABEL[stars])}</p>
        <textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={300} rows={2} placeholder={t("Anything to add? (optional)")}
          className="w-full rounded-xl border border-[#D2E0D8] p-3 text-base" data-testid="rating-comment" />
        <button onClick={send} disabled={busy} className="h-12 w-full rounded-2xl bg-[#0D3B2B] font-bold text-white disabled:opacity-60" data-testid="rating-submit-btn">{t("Submit rating")}</button>
      </>}
    </div>
  );
};
